import type { ReactNode } from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

export type QuickFilterButtonProps = {
  icon: ReactNode;
  label: string;
  count?: number;
  active: boolean;
  onClick: () => void;
  colorClass: string;
  activeBg: string;
  showClose?: boolean;
};

export const QuickFilterButton = ({
  icon,
  label,
  count,
  active,
  onClick,
  colorClass,
  activeBg,
  showClose,
}: QuickFilterButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      "flex items-center gap-1.5 rounded-full border px-4 py-2 text-sm font-semibold transition-all duration-150 hover:opacity-80",
      active ? cn(colorClass, activeBg) : cn(colorClass, "border-border bg-white opacity-80"),
    )}
  >
    {icon}
    <span>{label}</span>
    {showClose ? (
      <span
        className={cn(
          "flex size-5 items-center justify-center rounded-full",
          active ? "bg-white/60" : "bg-gray-100",
        )}
      >
        <X className="size-3.5" />
      </span>
    ) : (
      count !== undefined && <span className={active ? "opacity-80" : "opacity-60"}>{count}</span>
    )}
  </button>
);
